import type { PublishedEstimation } from '@tempo-io/roadmap-dto';
import { usePublishedContext } from '@/components/views/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/components/views/published/usePublishedSnapshotQuery';
import type { Estimation } from '@/lib/api/types/estimationScheme';
import { useEstimationsQuery } from '@/lib/queries/common/useGetEstimationScheme';
import { commonQueryKeys } from '@/lib/query-keys/common';

function mapPublishedEstimation(e: PublishedEstimation): Estimation {
  return {
    id: e.id,
    label: e.label,
    estimationSchemeId: e.estimationSchemeId,
    organizationId: '',
    highEffort: null,
    lowEffort: null,
    createdAt: '',
    updatedAt: '',
    createdBy: '',
    updatedBy: '',
    archivedAt: null,
  };
}

export const useEstimationsQueryWithPublished = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const estimationsQuery = useEstimationsQuery({ enabled: !isPublished && enabled });

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: commonQueryKeys.estimationSchemes.estimations,
    getSnapshot: () =>
      publishedContext ? publishedContext.estimations.map(mapPublishedEstimation) : undefined,
  });

  return isPublished ? publishedQuery : estimationsQuery;
};
